import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CampaignDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type CampaignDeleteMutationResponse = Pick<Types.Mutation, 'campaignDelete'>;

export const CampaignDeleteDocument = `
    mutation CampaignDelete($id: ID!) {
  campaignDelete(id: $id)
}
    `;

export const useCampaignDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CampaignDeleteMutationResponse,
    TError,
    CampaignDeleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CampaignDeleteMutationResponse,
    TError,
    CampaignDeleteMutationVariables,
    TContext
  >(
    ['CampaignDelete'],
    (variables?: CampaignDeleteMutationVariables) =>
      appFetcher<CampaignDeleteMutationResponse, CampaignDeleteMutationVariables>(
        CampaignDeleteDocument,
        variables,
      )(),
    options,
  );
};

useCampaignDeleteMutation.getKey = () => ['CampaignDelete'];
